import CustomersView from "../views/CustomersView.vue";
import ProvidersView from "../views/ProvidersView.vue";
import ProviderRequestsView from "../views/Statistics/ProviderRequestsView.vue";
import CustomerSelectedView from "../views/Statistics/CustomerSelectedView.vue";
import LandingPageView from "../views/LandingPageView.vue";

export default {
  title: "lookup engine",
  icon: "search",
  url: "lookupengine",
  routes: [
    {
      path: "/",
      name: "landing",
      component: LandingPageView,
      meta: { allowedGroups: ["Developer"] },
    },
    {
      path: "/customers",
      name: "customers",
      component: CustomersView,
      meta: { allowedGroups: ["Developer"] },
    },
    {
      path: "/providers",
      name: "providers",
      component: ProvidersView,
      meta: { allowedGroups: ["Developer"] },
    },
    {
      path: "/statistics/providers/requests",
      name: "providerrequests",
      component: ProviderRequestsView,
      meta: { allowedGroups: ["Developer"] },
    },
    {
      path: "/statistics/customers/selected",
      name: "customerselectedbreakdown",
      component: CustomerSelectedView,
      meta: { allowedGroups: ["Developer"] },
    },
  ],
  navbar: [
    {
      label: "Customers",
      route: "customers",
      requiredGroups: ["Developer"],
      children: [],
    },
    {
      label: "Providers",
      route: "providers",
      requiredGroups: ["Developer"],
      children: [],
    },
    {
      label: "Statistics",
      route: "",
      requiredGroups: ["Developer"],
      children: [
        {
          label: "Provider Requests",
          route: "providerrequests",
          requiredGroups: ["Developer"],
          children: [],
        },
        {
          label: "Customer Selected Breakdown",
          route: "customerselectedbreakdown",
          requiredGroups: ["Developer"],
          children: [],
        },
      ],
    },
  ],
  API_SERVERS: [
    {
      Name: "IRE",
      URL: "http://lookup-ireland.disctools.co.uk",
    },
    {
      Name: "UK",
      URL: "http://lookup-london.disctools.co.uk",
    },
    {
      Name: "CA",
      URL: "http://lookup-canada.disctools.co.uk",
    },
    {
      Name: "AUS",
      URL: "http://lookup-sydney.disctools.co.uk",
    },
    {
      Name: "North Virginia",
      URL: "http://lookup-northvirginia.disctools.co.uk",
    },
    {
      Name: "North California",
      URL: "http://lookup-northcalifornia.disctools.co.uk",
    },
    {
      Name: "Oregon",
      URL: "http://lookup-oregon.disctools.co.uk",
    },
    {
      Name: "Stockholm",
      URL: "http://eu-north-1.lookup.disctools.co.uk",
    },
    {
      Name: "DEV",
      URL: "http://localhost:8083",
    },
    {
      Name: "Staging",
      URL: "http://apple.disctools.co.uk",
    },
  ],
  GetAPIURL() {
    let apiURL = "";
    let selectedServer = localStorage.getItem("APIName");
    if (selectedServer == null) {
      const { Name } = this.API_SERVERS[0];
      selectedServer = Name;
      localStorage.setItem("APIName", selectedServer);
      apiURL = this.API_SERVERS[0].URL;
    } else {
      this.API_SERVERS.forEach((server) => {
        if (server.Name === selectedServer) {
          apiURL = server.URL;
        }
      });
    }

    return apiURL;
  },
  GetAPIName() {
    return localStorage.getItem("APIName");
  },
};
